import React, { Component,forwardRef } from 'react';
import { connect } from 'react-redux';
import { isEmpty, find, isUndefined } from 'lodash';
import MobileNumber from '../form/MobileNumber';
import Input from '../form/input';
// import Image from '../files/image';
import CountryNew from '../masterdata/CountryNew';
import StateNew from '../masterdata/StateNew';
import CityNew from '../masterdata/CityNew';
import PincodeNew from '../masterdata/PincodeNew';
// import Formatter from '../../utility/Formatter';
import { Masterdata, City, State, Pincode } from '../../utility/Masterdata';
import { CITY_PROFILE, PINCODE_PROFILE, STATE_PROFILE } from '../../utility/constants';

const cpInitialState = () => {
    return {
        countries: [],
        states: [],
        cities: [],
        pincodes: [],
    }
}

let cpGlobalState = {};

class CustomerProfile extends Component {
    constructor(props) {
        super(props);
        this.state = !isEmpty(cpGlobalState) ? cpGlobalState : cpInitialState();

        this.countryMas = Masterdata.getInstance();
        this.stateMas = State.getInstance();
        this.cityMas = City.getInstance();
        this.pincodeMas = Pincode.getInstance();

        this.handleLocationDetails = this.handleLocationDetails.bind(this);
    }

    /**
     * handle the response of country, city, state, pincode
     *
     * @param object - props
     */
    handleLocationDetails(props) {
        this.countryMas.set(props.countries);
        this.stateMas.set(props.statesProfile);
        this.cityMas.set(props.citiesProfile);
        this.pincodeMas.set(props.pincodesProfile);
        this.setState({
            countries: this.countryMas.getAll(),
            states: this.stateMas.getAll(),
            cities: this.cityMas.getAll(),
            pincodes: this.pincodeMas.getAll()
        });
    }

    componentWillReceiveProps(props) {
        this.handleLocationDetails(props);
    }

    componentWillUnmount() {
        // Remember state for the next mount
        cpGlobalState = this.state;
    }

    /**
     * Find the value in given data
     * @param string - key
     * @param string - value
     * @param array - data
     * @return boolean
     */
    findValue(key, value, data) {
        const val = find(data, { [key]: value });
        return isUndefined(val);
    }


    render() {
        if(localStorage.getItem('language')=="ar" && this.props.state.fields.customerCountryCode==="" ){
            this.props.state.fields.customerCountryCode="+966"
        }else
        if(localStorage.getItem('language')=="en" && this.props.state.fields.customerCountryCode==="" ){
            this.props.state.fields.customerCountryCode="+91"
        }
        return <React.Fragment>
            <div className="profilepersonaldtails profiledtailsset">
                <h2>{this.props.locale.common.personal_information}</h2>
                {!this.props.auth.isTclAdminUser() && ''
                    // <div className="form-group">
                    //     <label>{this.props.locale.customer.form.utility_type}</label>
                    //     <label>{this.props.state.fields.utilityName}</label>
                    // </div>
                }
                 {this.props.auth.isCustomerAdmin() && 
                <Input {...this.props}
                    fieldName={'customerName'}
                    value={this.props.state.fields.customerName}
                    labelName={this.props.locale.customer.form.customer_name}
                 validation={true} /> }
                  {this.props.auth.isProjectAdmin() && 
                <Input {...this.props}
                    fieldName={'projectName'}
                    value={this.props.state.fields.projectName}
                    labelName={this.props.locale.customer.form.project_name}
                 validation={true} /> }
                {/* <div className="form-group">
                            <label>{this.props.locale.customer.form.email_id}</label>
                            <label>{this.props.state.fields.emailId}</label>
                        </div> */}
                {this.props.auth.isCustomerAdmin() && 
                <Input {...this.props}
                    fieldName={'secondaryEmailId'}
                    value={this.props.state.fields.secondaryEmailId}
                    labelName={this.props.locale.customer.form.group_email_id}
                    validation={false}
                />
                }
                <MobileNumber {...this.props}
                    codeFieldName={'customerCountryCode'}
                    codeValue={this.props.state.fields.customerCountryCode}
                    fieldName={'mobileNumber'}
                    value={this.props.state.fields.mobileNumber}
                    labelName={this.props.locale.user.mobile_number}
                    //maxLength={10}
                    validation={false}
                />
                {/* <Input {...this.props}
                            dataType={"number"}
                            onChange={this.props.form.handleIntegerWithDashChange}
                            fieldName = {'phoneNumber'}
                            value={this.props.state.fields.phoneNumber}
                            labelName={this.props.locale.user.phone_number}
                            validation={true}
                            maxLength={12}
                        /> */}
                {/* <Image {...this.props}
                            labelName={this.props.locale.customer.form.customer_logo}
                            fieldName={'logo'}
                            dataName={"logo"}
                            value={Formatter.urlBasename(this.props.state.fields.logo)}
                        /> */}
            </div>
            <div className="profileaddressdtails profiledtailsset">
                <h2>{this.props.locale.common.address_information}</h2>
                {this.props.state.fields.address &&
                    <Input {...this.props}
                        fieldName={'addressLine1'}
                        dataName={'addressLine1'}
                        value={this.props.state.fields.addressLine1}
                        labelName={this.props.locale.customer.form.address_line1}
                        validation={true} />
                }
                {this.props.state.fields.address &&
                    <Input {...this.props}
                        fieldName={'addressLine2'}
                        dataName={'addressLine2'}
                        value={this.props.state.fields.addressLine2}
                        labelName={this.props.locale.customer.form.address_line2}
                        validation={false} />
                }
                {this.props.state.showModal &&
                    <CountryNew {...this.props}
                        defaultFetch={this.findValue('countryId', this.props.state.fields.countryId, this.state.countries)}
                        labelName={this.props.locale.customer.form.country}
                        select={{
                            "name": "countryId",
                            "data-name": "countryId",
                            'data-validation-name': this.props.locale.customer.form.country,
                            "value": this.props.state.fields.countryId
                        }}
                        data={this.state.countries}
                        mandatory={false}
                        //validation={false}
                    />
                }
                {this.props.state.showModal &&
                    <StateNew {...this.props}
                        defaultFetch={this.findValue('stateId', this.props.state.fields.stateId, this.state.states)}
                        labelName={this.props.locale.customer.form.state}
                        select={{
                            "name": "stateId",
                            "data-name": "stateId",
                            'data-validation-name': this.props.locale.customer.form.state,
                            "value": this.props.state.fields.stateId
                        }}
                        queryParams={{ countryId: this.props.state.fields.countryId, type: STATE_PROFILE }}
                        dependsOn={"countryId"}
                        data={this.state.states}
                        mandatory={false}
                        //validation={false}
                    />
                }
                {this.props.state.showModal &&
                    <CityNew {...this.props}
                        defaultFetch={this.findValue('cityId', this.props.state.fields.cityId, this.state.cities)}
                        labelName={this.props.locale.customer.form.city}
                        select={{
                            "name": "cityId",
                            "data-name": "cityId",
                            'data-validation-name': this.props.locale.customer.form.city,
                            "value": this.props.state.fields.cityId
                        }}
                        queryParams={{ stateId: this.props.state.fields.stateId, type: CITY_PROFILE }}
                        dependsOn={"stateId"}
                        data={this.state.cities}
                        mandatory={false}
                        //validation={false}
                    />
                }
                {this.props.state.showModal &&
                    <PincodeNew {...this.props}
                        defaultFetch={this.findValue('pincodeId', this.props.state.fields.pinCodeId, this.state.pincodes)}
                        labelName={this.props.locale.customer.form.pincode}
                        select={{
                            "name": "pinCodeId",
                            "data-name": "pinCodeId",
                            'data-validation-name': this.props.locale.customer.form.pincode,
                            "value": this.props.state.fields.pinCodeId
                        }}
                        queryParams={{ cityId: this.props.state.fields.cityId, type: PINCODE_PROFILE }}
                        dependsOn={"cityId"}
                        data={this.state.pincodes}
                        mandatory={false}
                        //validation={false}
                        
                    />
                }
            </div>
        </React.Fragment>
    }
}
const mapStateToProps = (state) => ({
    countries: state.countries,
    statesProfile: state.statesProfile,
    citiesProfile: state.citiesProfile,
    pincodesProfile: state.pincodesProfile,
  });
  
  const CustomerProfileWithRef = forwardRef((props, ref) => (
    <CustomerProfile {...props} ref={ref} />
  ));
  
  export default connect(mapStateToProps, null, null, { forwardRef: true })(
    CustomerProfileWithRef
  )